export default "__VITE_ASSET__uZLBXHZq__"